let showToast;
export function registerToastCallbacks(toast) {
    if (!showToast) {
        showToast = toast;
    }
}

export function showSuccessToast(msg) {
    showToast(msg);
}
export function showErrorToast(msg) {
    showToast(msg, 'error');
}
